module.exports = __webpack_public_path__ + "static/media/ONT-BNB.259e18e5.svg";